export const links = {
  interfaces: {
    link: "https://github.com/hackcharms/vue3-toaster#interfaces",
    Toaster: "https://github.com/hackcharms/vue3-toaster#interfaces",
    ToastVariant: "https://github.com/hackcharms/vue3-toaster#interfaces",
  },
  howToUse: {
    link: "https://github.com/hackcharms/vue3-toaster#how-to-use",
  },
  methods: {
    link: "https://github.com/hackcharms/vue3-toaster#methods",
    success: "https://github.com/hackcharms/vue3-toaster#success",
    warn: "https://github.com/hackcharms/vue3-toaster#warn",
    info: "https://github.com/hackcharms/vue3-toaster#info",
    error: "https://github.com/hackcharms/vue3-toaster#error",
  },
  slots: {
    link: "https://github.com/hackcharms/vue3-toaster#slots",
  },
  events: {
    link: "https://github.com/hackcharms/vue3-toaster#events",
  },
};
